import { AxiosInstance } from "axios";
import { Sap } from "../types/Sap";

export interface SapResponse {
  success: boolean;
  message: string;
  sap?: Sap;
}

export const sapService = {
  getAllSaps: async (api: AxiosInstance): Promise<Sap[]> => {
    try {
      const response = await api.get("/sap/all");
      return response.data as Sap[];
    } catch (error: any) {
      console.error("Erreur lors de la récupération des SAP :", error);
      throw error.response?.data || error;
    }
  },

  getSapById: async (api: AxiosInstance, id: number): Promise<Sap> => {
    try {
      const response = await api.get(`/sap/${id}`);
      if ((response.data as any).success === false) {
        throw new Error((response.data as any).message);
      }
      return response.data as Sap;
    } catch (error: any) {
      console.error(`Erreur lors de la récupération du SAP ${id} :`, error);
      throw error.response?.data || error;
    }
  },

  getSapByIdIndicateur: async (api: AxiosInstance, idIndicateur: number): Promise<Sap> => {
    try {
      const response = await api.get(`/sap/byIndicateur`, {
        params: { idIndicateur }
      });
      if ((response.data as any).success === false) {
        throw new Error((response.data as any).message);
      }
      return response.data as Sap;
    } catch (error: any) {
      console.error(`Erreur lors de la récupération du SAP pour l'indicateur ${idIndicateur} :`, error);
      throw error.response?.data || error;
    }
  },

  createSap: async (api: AxiosInstance, sap: Sap): Promise<SapResponse> => {
    try {
      const response = await api.post("/sap/create", sap);
      return response.data as SapResponse;
    } catch (error: any) {
      console.error("Erreur lors de la création du SAP :", error);
      return {
        success: false,
        message: error.response?.data?.message || "Erreur lors de la création du SAP"
      };
    }
  }
};